export default __webpack_public_path__ + "static/media/img11.851747f7.jpg";